// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   useTheme,
//   Drawer,
//   // Button,
//   // Tooltip,
//   useMediaQuery,
//   Tooltip,
//   Button,
// } from "@mui/material";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
// import "react-pro-sidebar/dist/css/styles.css";
// import { tokens } from "../theme";
// import { MenuItems } from "./navConfig";
// import Logo from "../assets/images/Povital-Logo.png";
// import SmallLogo from "../assets/images/Povital-Small.png";

// const Item = ({
//   title,
//   to,
//   icon,
//   selected,
//   setSelected,
//   isMobileView,
//   setToggleDrawer,
//   isLargeScreen, // new prop to check large screen
//   toggleDrawer,
// }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   const handleSelection = () => {
//     setSelected(title);
//     if (isMobileView) {
//       setToggleDrawer(false);
//     }
//   };

//   return (
//     <Tooltip title={isLargeScreen && toggleDrawer && title} placement="right">
//       <MenuItem
//         active={selected === title}
//         style={{
//           // color: colors.grey[100],
//           color: "#454545",
//         }}
//         onClick={handleSelection}
//         icon={icon}
//       >
//         {/* Conditionally render title */}
//         {isLargeScreen && !toggleDrawer && <Typography>{title}</Typography>}
//         <Link to={to} />
//       </MenuItem>
//     </Tooltip>
//   );
// };

// const Sidebar = ({ toggleDrawer, setToggleDrawer }) => {
//   const menuItems = MenuItems();
//   const location = useLocation();
//   const currentPath = location.pathname;
//   const navigate = useNavigate();
//   // const navigate = useNavigate();
//   // const isActiveRole = "super_admin";
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [selected, setSelected] = useState("Dashboard");
//   const [isMobileView, setIsMobileView] = useState(
//     window.innerWidth < theme.breakpoints.values.md
//   );
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up("md")); // detect large screen
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);

//   useEffect(() => {
//     const selectedItem = menuItems.find((nav) => nav.path === currentPath);
//     setSelected(selectedItem?.title);
//   }, [currentPath, menuItems]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth < theme.breakpoints.values.md);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, [theme.breakpoints.values.md]);

//   const SidebarContent = (
//     <Box
//       sx={{

//         "& .pro-sidebar-inner": {
//           background: `${colors.primary[400]} !important`,
//           pb: 2,
//           pt: 8,
//           position: "relative",
//           width: isLargeScreen && toggleDrawer ? "80px" : "250px !important", // Adjust width
//           transition: "width 0.3s ease-out",
//           zIndex: isLargeScreen && toggleDrawer ? 999 : 997, // Adjust width
//         },
//         "& .pro-icon-wrapper": {
//           backgroundColor: "transparent !important",
//         },
//         "& .pro-inner-item": {
//           p: "8px 22px !important",
//         },
//         "& .pro-inner-item:hover": {
//           color: `#4285f4  !important`,
//           borderLeft: `2px solid ${colors.blueAccent[400]}`,
//           transition: "width 0.3s ease-out, background-color 0.3s ease-out",
//         },
//         "& .pro-menu-item.active": {
//           // color: `${colors.blueAccent[400]} !important`,
//           color: `#4284f5 !important`,

//           borderLeft: `2px solid ${colors.blueAccent[400]}`,
//         },
//         "& .logo": {
//           display: "flex",
//           justifyContent: isLargeScreen && toggleDrawer ? "left" : "center",
//           position: "fixed",
//           top: 0,
//           zIndex: 100,
//           bgcolor: colors.primary[400],
//           height: 64,
//         },
//         "& .logo img": {
//           height: isLargeScreen && toggleDrawer ? "75px" : "75px",
//           padding:
//             isLargeScreen && toggleDrawer
//               ? "12px 22px 22px 22px"
//               : "12px 20px 20px 20px",
//           transition: "width 0.3s ease-out",
//         },
//         bgcolor: `${colors.primary[400]} !important`,
//         height: "100vh",
//       }}
//     >
//       <Box
//         sx={{
//           [theme.breakpoints.down("lg")]: {
//             display: "block",
//           },
//           height: "100%",
//           background: `${colors.primary[400]} !important`,
//         }}
//       >
//         <ProSidebar>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <Box className="logo" sx={{ cursor: "pointer" }}>
//               <img
//                 src={isLargeScreen && toggleDrawer ? SmallLogo : Logo}
//                 alt="Logo"
//               />
//             </Box>
//           </Box>
//           <Menu iconShape="square" style={{ padding: 0, height: "100%" }}>
//             {menuItems?.map((nav, idx) => (
//               <div key={idx}>
//                 {nav?.children ? (
//                   <SubMenu title={nav.title} icon={nav.icon}>
//                     {nav?.children?.map((child, childIdx) => (
//                       <Item
//                         key={childIdx}
//                         title={child.title}
//                         to={child.path}
//                         icon={child.icon}
//                         selected={selected}
//                         setSelected={setSelected}
//                         setToggleDrawer={setToggleDrawer}
//                         isMobileView={isMobileView}
//                         isLargeScreen={isLargeScreen} // passing the isLargeScreen prop
//                         toggleDrawer={toggleDrawer}
//                       />
//                     ))}
//                   </SubMenu>
//                 ) : (
//                   <Item
//                     title={nav.title}
//                     to={nav.path}
//                     icon={nav.icon}
//                     selected={selected}
//                     setSelected={setSelected}
//                     setToggleDrawer={setToggleDrawer}
//                     isMobileView={isMobileView}
//                     isLargeScreen={isLargeScreen} // passing the isLargeScreen prop
//                     toggleDrawer={toggleDrawer}
//                   />
//                 )}
//               </div>
//             ))}
//           </Menu>

//         </ProSidebar>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         // position: "relative",
//         width: isLargeScreen && toggleDrawer ? "80px" : "250px !important", // Adjust width
//         transition: "width 0.3s ease-out",
//         zIndex: isLargeScreen && toggleDrawer ? 998 : 999, // Adjust width
//       }}
//     >
//       {isMobileView ? (
//         <Drawer
//           variant="temporary"
//           anchor="left"
//           open={toggleDrawer}
//           onClose={() => setToggleDrawer(false)}
//         >
//           {SidebarContent}
//         </Drawer>
//       ) : (
//         SidebarContent
//       )}
//     </Box>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  useTheme,
  Drawer,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../theme";
import { MenuItems } from "./navConfig";
import Logo from "../assets/images/Povital-Logo.png";
import SmallLogo from "../assets/images/Povital-Small.png";
import InviteDrawer from "../screens/Invite/InviteDrawer";

// New InviteDrawer component

const Item = ({
  title,
  to,
  icon,
  selected,
  setSelected,
  isMobileView,
  setToggleDrawer,
  isLargeScreen,
  toggleDrawer,
  onInviteClick, // New prop for handling invite click
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleSelection = () => {
    setSelected(title);
    if (title === "Invite To Recruiter" || title === "Invite To Bench Sales") {
      onInviteClick(); // Call the invite click handler
    } else if (isMobileView) {
      setToggleDrawer(false);
    }
  };

  return (
    <Tooltip title={isLargeScreen && toggleDrawer && title} placement="right">
      <MenuItem
        active={selected === title}
        style={{
          color: "#454545",
        }}
        onClick={handleSelection}
        icon={icon}
      >
        {isLargeScreen && !toggleDrawer && <Typography>{title}</Typography>}
        {title !== "Invite To Recruiter" && title !== "Invite To Bench Sales"  && <Link to={to} />}
      </MenuItem>
    </Tooltip>
  );
};

const Sidebar = ({ toggleDrawer, setToggleDrawer }) => {
  const menuItems = MenuItems();
  const location = useLocation();
  const currentPath = location.pathname;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("Dashboard");
  const [isMobileView, setIsMobileView] = useState(
    window.innerWidth < theme.breakpoints.values.md
  );
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const [isInviteDrawerOpen, setIsInviteDrawerOpen] = useState(false); // State for invite drawer

  useEffect(() => {
    const selectedItem = menuItems.find((nav) => nav.path === currentPath);
    setSelected(selectedItem?.title);
  }, [currentPath, menuItems]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < theme.breakpoints.values.md);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [theme.breakpoints.values.md]);

  // Handler for opening invite drawer
  const handleInviteClick = () => {
    setIsInviteDrawerOpen(true);
  };

  const SidebarContent = (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
          pb: 2,
          pt: 8,
          position: "relative",
          width: isLargeScreen && toggleDrawer ? "80px" : "250px !important",
          transition: "width 0.3s ease-out",
          zIndex: isLargeScreen && toggleDrawer ? 999 : 997,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          p: "8px 22px !important",
        },
        "& .pro-inner-item:hover": {
          color: `#4285f4  !important`,
          borderLeft: `2px solid ${colors.blueAccent[400]}`,
          transition: "width 0.3s ease-out, background-color 0.3s ease-out",
        },
        "& .pro-menu-item.active": {
          color: `#4284f5 !important`,
          borderLeft: `2px solid ${colors.blueAccent[400]}`,
        },
        "& .logo": {
          display: "flex",
          justifyContent: isLargeScreen && toggleDrawer ? "left" : "center",
          position: "fixed",
          top: 0,
          zIndex: 100,
          bgcolor: colors.primary[400],
          height: 64,
        },
        "& .logo img": {
          height: isLargeScreen && toggleDrawer ? "75px" : "75px",
          padding:
            isLargeScreen && toggleDrawer
              ? "12px 22px 22px 22px"
              : "12px 20px 20px 20px",
          transition: "width 0.3s ease-out",
        },
        bgcolor: `${colors.primary[400]} !important`,
        height: "100vh",
      }}
    >
      <Box
        sx={{
          [theme.breakpoints.down("lg")]: {
            display: "block",
          },
          height: "100%",
          background: `${colors.primary[400]} !important`,
        }}
      >
        <ProSidebar>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box className="logo" sx={{ cursor: "pointer" }}>
              <img
                src={isLargeScreen && toggleDrawer ? SmallLogo : Logo}
                alt="Logo"
              />
            </Box>
          </Box>
          <Menu iconShape="square" style={{ padding: 0, height: "100%" }}>
            {menuItems?.map((nav, idx) => (
              <div key={idx}>
                {nav?.children ? (
                  <SubMenu title={nav.title} icon={nav.icon}>
                    {nav?.children?.map((child, childIdx) => (
                      <Item
                        key={childIdx}
                        title={child.title}
                        to={child.path}
                        icon={child.icon}
                        selected={selected}
                        setSelected={setSelected}
                        setToggleDrawer={setToggleDrawer}
                        isMobileView={isMobileView}
                        isLargeScreen={isLargeScreen}
                        toggleDrawer={toggleDrawer}
                        onInviteClick={handleInviteClick} // Pass invite click handler
                      />
                    ))}
                  </SubMenu>
                ) : (
                  <Item
                    title={nav.title}
                    to={nav.path}
                    icon={nav.icon}
                    selected={selected}
                    setSelected={setSelected}
                    setToggleDrawer={setToggleDrawer}
                    isMobileView={isMobileView}
                    isLargeScreen={isLargeScreen}
                    toggleDrawer={toggleDrawer}
                    onInviteClick={handleInviteClick} // Pass invite click handler
                  />
                )}
              </div>
            ))}
          </Menu>
        </ProSidebar>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        width: isLargeScreen && toggleDrawer ? "80px" : "250px !important",
        transition: "width 0.3s ease-out",
        zIndex: isLargeScreen && toggleDrawer ? 998 : 999,
      }}
    >
      {isMobileView ? (
        <Drawer
          variant="temporary"
          anchor="left"
          open={toggleDrawer}
          onClose={() => setToggleDrawer(false)}
        >
          {SidebarContent}
        </Drawer>
      ) : (
        SidebarContent
      )}
      <InviteDrawer
        open={isInviteDrawerOpen}
        onClose={() => setIsInviteDrawerOpen(false)}
      />
    </Box>
  );
};

export default Sidebar;
